import { defineStore } from 'pinia';
import { getCustomerTypeListApi } from '/@/api/admin/customer';
import {
  getFollowCategoryListApi,
  getStructureListApi,
  getUserListApi,
  getSourceListApi,
  getZoneListApi,
} from '/@/api/sys/common';
import { store } from '/@/store';

export const useSysStore = defineStore({
  id: 'app-sys',
  state: () => ({
    followCategoryList: [],
    customerTypesList: [],
    allUserList: [],
    structureList: [],
    sourceList: [],
    zoneList: [],
  }),
  actions: {
    async getAllFieldList() {
      await Promise.all([
        this.setCustomerTypesList(),
        this.setAllUserList(),
        this.setStructureList(),
        this.setCustomerSourceList(),
        this.setZoneList(),
      ]);
    },
    async setFollowCategoryList() {
      if (this.followCategoryList.length === 0) {
        this.followCategoryList = await getFollowCategoryListApi({});
      }
    },
    async setCustomerTypesList() {
      if (this.customerTypesList.length === 0) {
        this.customerTypesList = await getCustomerTypeListApi({});
      }
    },
    async setAllUserList() {
      if (this.allUserList.length === 0) {
        this.allUserList = (await getUserListApi({ by: 'alluser' })).map((i) => ({
          label: i.realname,
          value: i.id,
        }));
      }
    },

    async setStructureList() {
      if (this.structureList.length === 0) {
        this.structureList = await getStructureListApi({ type: 'tree' });
      }
    },

    async setCustomerSourceList() {
      if (this.sourceList.length === 0) {
        this.sourceList = await getSourceListApi({ tree: 1 });
      }
    },

    async setZoneList() {
      if (this.zoneList.length === 0) {
        this.zoneList = (await getZoneListApi({})).map((i) => ({
          label: i.name,
          value: i.zoneId,
        }));
      }
    },
  },
});

// Need to be used outside the setup
export function useSysStoreWithOut() {
  return useSysStore(store);
}
